export const keys = {
    all: ["user-activity-log"]
};
